/*
 * @Date: 2024-03-11 16:40:33
 * @LastEditors: fangdong dong.fang@quvideo.com
 * @LastEditTime: 2024-03-11 17:14:43
 * @FilePath: /video-marketing/config/index.ts
 */
import base from './base';
import { cnConfig } from './cn';
import { overseaConfig } from './oversea';

const fetchConfig = (env: string) => {
  if (env === 'cn') {
    return cnConfig;
  } else if (env === 'oversea') {
    return overseaConfig;
  } else {
    return {};
  }
};
const mergeConfig = fetchConfig(process.env.APP_AREA as string);

const config = Object.assign(base, mergeConfig);

export const APP_LANDING = config.APP_LANDING;
export const COOKIE_DOMAIN = config.COOKIE_DOMAIN;
export default config;
